// extracted by mini-css-extract-plugin
export var dataCell = "_kv-2";
export var dataRow = "_kv-0";
export var headerRow = "_kv-1";